<!--
  Same guard as FortePayment.vue: Enter is swallowed on the pay button so it cannot both open
  Forte's checkout and fire an ancestor's Enter handler; a click first clears any blank Forte
  container an earlier attempt left, and teardown sweeps them. See util/forte-checkout.js.
-->
<template>
  <button
    type="button"
    :api_access_id="forteConfig.apiAccessId"
    :version_number="forteConfig.versionNumber"
    :method="forteConfig.method"
    :location_id="forteConfig.locationId"
    :total_amount="forteConfig.totalAmount"
    :utc_time="forteConfig.utcTime"
    :order_number="forteConfig.tmcLocalTrusts"
    :signature="forteConfig.apiSignature"
    :line_item_header="lineItemHeader"
    v-bind="dynamicLineItems"
    allowed_methods="visa,mast,disc,amex"
    callback = 'forteCb'
    hash_method="sha1"
    save_token="false"
    swipe="true"
    billing_company_name_attr="hide"
    @keydown.enter.prevent.stop
    @click="sweepForteOrphans"
  >
    Proceed to Pay
  </button>
</template>
<script>
import {
  mapState,
  mapActions,
} from 'vuex';
import {
  forteApiModes,
} from '../../util/shared/tmc-global';
import { amountToNumber } from '../../util/shared/vue-global';
import { removeOrphanForteContainers } from '../../util/forte-checkout';

let self;

const cleanupDuplicateDialog = () => {
  // forte has static class for dialog
  const dialog = document.getElementsByClassName('fco2-iframe-container');
  const dialogCount = (dialog || []).length;
  if (dialogCount > 1) {
    for (let i = 1; i < dialogCount; i += 1) {
      dialog[i].remove();
    }
  }
};

const forteCb = (e) => {
  cleanupDuplicateDialog();
  let response = {};
  try {
    response = JSON.parse(e.data);
  } catch (err) {
    /* do nothing for now */
    // console.error(err);
  }
  switch (response.event) {
    case 'begin':
      // do nothing
      break;
    case 'abort':
      // do nothing
      break;
    case 'success':
      // transaction successful
      self.$emit('forteResponse', response);
      alert(`Thanks for your order. the trace number is ${response.trace_number}`);
      break;
    case 'failure':
      // handle failed transaction
      alert(`Sorry, transaction failed. failed reason is  ${response.response_description}`);
      break;
    default:
      // do nothing
      break;
  }
};

const defaultForteApiURL = () => forteApiModes[0].apiURL;

export default {
  name: 'ForteTaxPayment',
  props: {
    taxPaymentForte: {
      type: Object,
      default: () => ({}),
    },
    lineItemHeader: {
      type: String,
      default: 'Final,Year,TID,Tax_Amount,Penalty,Fee,Total',
    },
  },
  data: () => ({
    forteConfig: {},
    forteSuccess: {},
  }),
  async mounted() {
    self = this;
    window.forteCb = forteCb;
    this.buildForteUtility();
  },
  beforeDestroy() {
    removeOrphanForteContainers();
  },
  computed: {
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem || {},
    }),
    dynamicLineItems() {
      const lineItems = {};
      (this.taxPaymentForte.taxDetails || []).forEach((item, index) => {
        const taxId = String(item.taxId || 0).padStart(7, '0');
        const currObj = [
          'final',
          item.taxYear,
          taxId,
          `$${amountToNumber(item.taxAmt).toFixed(2)}`,
          `$${amountToNumber(item.penaltyAmt).toFixed(2)}`,
          `$${amountToNumber(item.totalFees).toFixed(2)}`,
          `$${amountToNumber(item.total).toFixed(2)}`,
        ].join(',');
        lineItems[`line_item_${index + 1}`] = currObj;
      });
      return lineItems;
    },
  },
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    // Wrapped so the click event is not handed to the util as its `doc` argument.
    sweepForteOrphans() {
      removeOrphanForteContainers();
    },
    ...mapActions([
      'flashWarn',
    ]),
    async buildForteUtility() {
      await this.loadConfig({ requiredScope: 'global' });
      const forteApiURL = this.globalSettingItem.forteApiURL || defaultForteApiURL();
      const fortePaymentScript = document.createElement('script');
      fortePaymentScript.setAttribute('src', forteApiURL);
      document.head.appendChild(fortePaymentScript);
      this.forteConfig = this.$store.state.ForteService.forteConfig || {};
      if (forteApiURL === defaultForteApiURL()) {
        this.flashWarn('Your Forte account is operating in "Sandbox Mode". If you wish to accept live payments, please update your Forte setting.');
      }
    },
  },
};
</script>
